import React, { useState, useEffect } from 'react';
import {
  Container,
  TextField,
  Button,
  Typography,
  Paper,
  Box,
  Grid,
  Chip
} from '@mui/material';
import { ArrowBack, Save, Edit } from '@mui/icons-material';
import { editarTipoCampana } from '../../../actions/CampanasAction';
import { useStateValue } from '../../../contexto/store';
import { RegistrarAccion } from '../../../actions/AuditoriaAction';

const ModificarTipoCampana = (props) => {
  const tipoCampanaAModificar = props.location.state;
  //eslint-disable-next-line
  const [{ openSnackar, sesionUsuario }, dispatch] = useStateValue();

  const [tipoCampana, setTipoCampana] = useState({
    id: '',
    CODTIPOCAMPANA: 0,
    DESCRITIPOCAMPANA: '',
  });

  useEffect(() => {
    if (tipoCampanaAModificar) {
      setTipoCampana({
        id: tipoCampanaAModificar.tipocampanA_Id || '',
        CODTIPOCAMPANA: tipoCampanaAModificar.codtipocampana || 0,
        DESCRITIPOCAMPANA: tipoCampanaAModificar.descritipocampana || '',
      });
    }
  }, [tipoCampanaAModificar]);

  const ingresarValoresMemoria = (e) => {
    const { name, value } = e.target;
    setTipoCampana((anterior) => ({
      ...anterior,
      [name]: value,
    }));
  };

  const volverTabla = (e) => {
    props.history.push('/tiposcampanas');
  };

  //RRR: FUNCION PARA ACTUALIZAR TIPO DE CAMPAÑA
  const actualizarTipoCampana = (e) => {
    e.preventDefault();
    const objetoModTipoCampana = {
      CODTIPOCAMPANA: parseInt(tipoCampana.CODTIPOCAMPANA),
      DESCRITIPOCAMPANA: tipoCampana.DESCRITIPOCAMPANA,
    };
    editarTipoCampana(
      tipoCampanaAModificar.tipocampanA_Id,
      objetoModTipoCampana
    ).then((response) => {
      if (response.status === 200) {
        dispatch({
          type: 'OPEN_SNACKBAR',
          openMensaje: {
            open: true,
            mensaje: 'Se Modifico exitosamente el Tipo de Campana',
          },
        });
        setTipoCampana({
          id: '',
          CODTIPOCAMPANA: 0,
          DESCRITIPOCAMPANA: '',
        });
        let objetoAudi = {
          usuario: sesionUsuario.usuario.nombrecompleto,
          accion: 'Modificacion',
          panel: 'Seguridad',
          tabla: 'TIPOSCAMPAÑAS',
          filaafectada: props.location.state.clientE_Id,
          UsuarioId: sesionUsuario.usuario.id,
        };
        RegistrarAccion(objetoAudi);
      } else {
        dispatch({
          type: 'OPEN_SNACKBAR',
          openMensaje: {
            open: true,
            mensaje: 'Errores al intentar guardar ',
          },
        });
      }
    });
  };

  return (
    <Container maxWidth="md" sx={{ mt: 4, mb: 4 }}>
      <Paper
        elevation={0}
        sx={{
          p: 4,
          border: '1px solid',
          borderColor: 'divider',
          borderRadius: 2,
        }}
      >
        <Box sx={{ mb: 3 }}>
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 2 }}>
            <Edit color="primary" />
            <Typography variant="h4" component="h1" sx={{ fontWeight: 600 }}>
              Modificar Tipo de Campaña
            </Typography>
          </Box>
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
            <Typography variant="body2" color="text.secondary">
              Editando:
            </Typography>
            <Chip 
              label={tipoCampanaAModificar.descritipocampana} 
              color="primary" 
              variant="outlined"
              size="small"
            />
          </Box>
        </Box>

        <Box component="form" noValidate>
          <Grid container spacing={3}>
            <Grid item xs={12}>
              <TextField
                name="DESCRITIPOCAMPANA"
                value={tipoCampana.DESCRITIPOCAMPANA}
                fullWidth
                onChange={ingresarValoresMemoria}
                variant="outlined"
                label="Descripción *"
                placeholder="Ingrese la descripción del tipo de campaña"
                required
              />
            </Grid>

            <Grid item xs={12}>
              <Box sx={{ display: 'flex', gap: 2, justifyContent: 'flex-end', mt: 2 }}>
                <Button
                  variant="outlined"
                  startIcon={<ArrowBack />}
                  onClick={volverTabla}
                  sx={{
                    px: 3,
                    py: 1.5,
                    borderRadius: 2,
                    textTransform: 'none',
                  }}
                >
                  Volver
                </Button>
                <Button
                  variant="contained"
                  startIcon={<Save />}
                  onClick={actualizarTipoCampana}
                  sx={{
                    px: 3,
                    py: 1.5,
                    borderRadius: 2,
                    textTransform: 'none',
                    background: 'linear-gradient(135deg, #1976d2 0%, #0d47a1 100%)',
                    '&:hover': {
                      background: 'linear-gradient(135deg, #1976d2 20%, #0d47a1 120%)',
                    },
                  }}
                >
                  Actualizar
                </Button>
              </Box>
            </Grid>
          </Grid>
        </Box>
      </Paper>
    </Container>
  );
};

export default ModificarTipoCampana;
